import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function XIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M19.5673 4.49055C19.8382 4.17721 19.8038 3.70358 19.4905 3.43267C19.1772 3.16176 18.7035 3.19614 18.4326 3.50948L13.151 9.61809L8.65997 3.63001C8.48056 3.3908 8.19899 3.25001 7.89997 3.25001H4.39997C3.61713 3.25001 3.17026 4.14374 3.63997 4.77001L9.93236 13.1599L4.43306 19.509C4.16187 19.8221 4.19584 20.2957 4.50894 20.5669C4.82203 20.8381 5.29569 20.8041 5.56688 20.491L10.8533 14.3878L15.34 20.37C15.5194 20.6092 15.8009 20.75 16.1 20.75H19.6C20.3828 20.75 20.8297 19.8563 20.36 19.23L14.0721 10.8462L19.5673 4.49055Z"
        fill="currentColor"
      />
    </svg>
  )
}
